export const nav = [
  {
    id: 1,
    text: "home",
    url: "/",
  },
  {
    id: 2,
    text: "about",
    url: "/about",
  },
  {
    id: 3,
    text: "pages",
    url: "/pages",
  },
  {
    id: 4,
    text: "blog",
    url: "/blog",
  },
  {
    id: 5,
    text: "contact",
    url: "/contact",
  },
];
export const category = [
  {
    id: 1,
    category: "Life",
    title: "Stay Calm And Surf",
    cover: "../images/category/ca1.png",
  },
  {
    id: 2,
    category: "Fashion",
    title: "Becoming a Dragonfly",
    cover: "../images/category/ca2.png",
  },
  {
    id: 3,
    category: "Travel",
    title: "There's always light at the end of the tunnel",
    cover: "../images/category/ca3.png",
  },
  {
    id: 4,
    category: "Sport",
    title: "Stay Calm And Surf",
    cover: "../images/category/ca4.png",
  },
  {
    id: 5,
    category: "Fun",
    title: "There's always light at the end of the tunnel",
    cover: "../images/category/ca5.png",
  },
  {
    id: 6,
    category: "Health",
    title: "Becoming a Dragonfly",
    cover: "../images/category/ca6.png",
  },
  {
    id: 7,
    category: "Business",
    title: "Stay Calm And Surf",
    cover: "../images/category/ca7.png",
  },
  {
    id: 8,
    category: "Technology",
    title: "There's always light at the end of the tunnel",
    cover: "../images/category/ca8.png",
  },
];
export const blog = [
  {
    id: 1,
    title: "ABOUT US",
    desc: "D'n'D Rodhak is a dynamic tech startup founded on August 15th, 2019, at IIT Mandi, Himachal Pradesh. We are proud to have been shortlisted in the top 25 startups at Hill StartUp Trek 2019, organized by IIT Mandi Catalyst. This recognition earned us the opportunity to be funded while participating in the exploration program, fueling our passion for innovation and road safety solutions.  Our commitment to excellence has been acknowledged by esteemed organizations such as DST (Department of Science and Technology) and HPCED (Himachal Pradesh Centre for Entrepreneurship Development). Through their support, we have received sustenance allowance for an entire year, allowing us to focus on refining our products and creating a lasting impact on road safety.At D'n'D Rodhak, we have showcased our technical prowess and industry expertise by presenting a technical manuscript at the International Conference on Computing, Communications, and Networking Technologies 2020, held at IIT Kharagpur. This platform has further validated our dedication to pushing the boundaries of cutting-edge technologies such as Internet of Things (IoT), Machine Learning, and 5G.Recognition for our innovative solutions extends beyond the local level. We are proud to have been shortlisted in the top 100 startups at the national level 5G Hackathon, where we were granted the opportunity to refine our products. This acknowledgment motivates us to continue our pursuit of excellence and contribute to revolutionizing road safety.Our mission at D'n'D Rodhak is simple yet profound: Your Safety, Our Responsibility! We are based in the picturesque town of Mandi, Himachal Pradesh, where our dedicated team of founders and professionals work tirelessly to develop state-of-the-art road safety solutions.Founders:- Pranay Sharma - Naveksha Sood",
    category: "details",
    cover: "../images/blogs/b9.jpg",
    date: "February 20, 2018",
  },

  {
    id: 2,

    title:
      "Mastering Time Management: Embrace Efficiency with HimRaahi and D'n'D Rodhak",
    desc: "In our fast-paced world, time management has become more crucial than ever. Balancing work, personal commitments, and the well-being of our loved ones requires a strategic approach to ensure everything runs smoothly. Whether it's picking up our kids from school or keeping a watchful eye on the journeys of our loved ones to and from Himachal Pradesh, effective time management plays a pivotal role. In this blog, we will explore the significance of time management in these scenarios and introduce two innovative products, HimRaahi and D'n'D Rodhak, that are specifically designed to save time and enhance overall efficiency .",
    category: "Time Management",
    cover: "../images/blogs/b4.jpg",
    date: "February 20, 2018",
  },
  {
    id: 3,
    title: "Who we Serve?",
    desc: "HimRaahi and D'n'D Rodhak cater to various customer segments, including schools, offices, universities, taxi fleet owners, bus owners, private vehicle owners and families, as well as tour and travel operators. These products offer a range of features and capabilities to enhance safety, time management, and overall efficiency in transportation operations.",
    category: "Benefits",
    cover: "../images/blogs/b5.jpg",
    date: "February 20, 2018",
  },
  {
    id: 4,
    title: "Streamline Your Fleet Management with HimRaahi and D'n'D Rodhak",
    desc: "Efficient fleet management is the backbone of successful businesses that rely on transportation. Whether you have a small fleet or a large-scale operation, effectively monitoring and optimizing your vehicles can make a significant difference in terms of cost savings, productivity, and customer satisfaction. In this blog post, we'll introduce you to two innovative solutions that can revolutionize your fleet management: HimRaahi and D'n'D Rodhak. These products offer a range of features and benefits designed to simplify your operations and maximize your fleet's performance.    ",
    category: "Management",
    cover: "../images/blogs/b6.jpg",
    date: "February 20, 2018",
  },
  {
    id: 5,
    title:
      " Safeguarding Lives and Property: The Power of HimRaahi and D'n'D Rodhak in Preventing Road Accidents    ",
    desc: "Road accidents have long been a global concern, causing devastating consequences for both lives and property. While various factors contribute to these accidents, technological advancements have opened new avenues for preventing such tragedies. In this blog post, we will explore the causes behind road accidents and shed light on two remarkable products—HimRaahi and D'n'D Rodhak—that aim to mitigate accidents, saving lives and preventing loss of property.    ",
    category: "Safety",
    cover: "../images/blogs/b7.jpg",
    date: "February 20, 2018",
  },

  {
    id: 8,
    title:
      "Enhancing Safety in Himachal Pradesh's Hilly Terrain with Vehicle Tracking Solution",
    desc: "**Nestled amidst the breathtaking beauty of the Himalayas, Himachal Pradesh** is renowned for its picturesque landscapes and winding roads that attract countless travelers each year. However, these stunning hilly areas also present unique challenges when it comes to road safety. The steep slopes, narrow pathways, and unpredictable weather conditions make it crucial to prioritize safety measures, particularly for vehicles traversing through this terrain. In this blog, we will explore the pressing need for vehicle tracking and safety solutions in Himachal Pradesh and shed light on two exceptional products—**HimRaahi** and **D'n'D Rodhak**—that are revolutionizing road safety in the region.\n\n**The Need for Vehicle Tracking and Safety**:\n\n**Himachal Pradesh's hilly terrain** poses numerous risks for motorists. The winding roads and steep inclines demand exceptional driving skills and heightened awareness. Inclement weather conditions, such as heavy rain, fog, or snowfall, further increase the likelihood of accidents. Additionally, the absence of proper infrastructure, narrow roadways, and lack of guardrails compound the dangers faced by drivers and passengers.\n\nIn such challenging circumstances, vehicle tracking and safety systems emerge as indispensable tools. These technologies provide real-time monitoring, ensuring the well-being of passengers, reducing accident rates, and preventing the loss of property. Let's delve into two remarkable solutions making a significant impact in this space.\n\n**1. HimRaahi: Empowering Businesses with Basic Software**:\nnHimRaahi is a cutting-edge software-based vehicle tracking system that offers essential safety features designed to address the unique needs of Himachal Pradesh's hilly regions. This user-friendly platform provides businesses and fleet owners with real-time tracking and monitoring of their vehicles. With HimRaahi, companies can ensure the safety of their drivers, passengers, and valuable assets, all at the click of a button.\n\n**2. D'n'D Rodhak: Advanced Hardware and Software for Enhanced Safety**:\n\nFor those seeking a comprehensive safety solution that goes beyond software, D'n'D Rodhak is the ultimate choice. This premium offering combines cutting-edge hardware with advanced software, providing an unparalleled level of safety and peace of mind.\n\n**Key Features of D'n'D Rodhak**:\n\n- All features of HimRaahi: Enjoy the full range of benefits offered by HimRaahi's software, including real-time tracking, route optimization, and historical data analysis.\n- Collision detection and prevention: Equipped with sensors and sophisticated algorithms, D'n'D Rodhak detects potential collisions and alerts drivers to take immediate action, preventing accidents.\n- Vehicle diagnostics: Monitor vehicle health, detect maintenance issues, and receive proactive notifications to ensure optimal performance and minimize breakdowns.\n- Driver behavior analysis: Identify and address risky driving behaviors such as harsh braking, speeding, or rapid acceleration, promoting safer driving practices.\n\n**Saving Lives and Protecting Property**:\nThe implementation of vehicle tracking and safety solutions like HimRaahi and D'n'D Rodhak is instrumental in mitigating the risks associated with driving in Himachal Pradesh's hilly areas. By preventing accidents and enabling prompt response in emergencies, these technologies not only save lives but also safeguard valuable assets, reducing financial losses.\n\n**Conclusion**:\nThe captivating landscapes of Himachal Pradesh",
    category: "Safety",
    cover: "../images/blogs/b1.jpg",
    date: "APRIL 05, 2018",
  },
];
